<template>
	<div>
		<tabs animation="slide" :only-fade="false" alignment="center" :is-fullwidth="true"  class="primary-tabs">
			<tab-pane :label="t('pending')" selected>
				<div class="p10 has-text-weight-bold orders-table-header">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<p class="has-text-centered has-text-grey">{{ t('product_image') }}</p>
								</div>
								<div class="column is-9 has-text-right">
									<p class="has-text-centered has-text-grey">{{ t('product_name') }}</p>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary">
							<div class="columns height-full">
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('product_price') }}</p>
								</div>
								<div class="column is-4">
									<p v-if="CategoryType === 'quantity'" class="has-text-centered has-text-grey">{{ t('quantity') }}</p>
									<p v-if="CategoryType === 'date'" class="has-text-centered has-text-grey">{{ t('date') }}</p>
									<p v-if="CategoryType === 'date_time'" class="has-text-centered has-text-grey">{{ t('date_time') }}</p>
									<p v-if="CategoryType === 'fixed_date'" class="has-text-centered has-text-grey">{{ t('period') }}</p>
								</div>
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('details') }}</p>
								</div>
							</div>
						</div>
						<div class="column is-2">
						</div>
					</div>
				</div>
				<div v-if="agentDesktop" class="orders-table-desktop">
					<div v-for="product in pendingProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns">
							<div class="column is-5">
								<div class="columns height-full">
									<div class="column is-3">
										<a rel="noreferrer" href="#">
											<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
												<lazy-load
												src="/front/img/spinner.svg"
												:lazy-src="product.image"
												:lazy-srcset="product.image"
												background-color="transparent"
												:alt="product.product_name"
												class="hvr-grow"
												:lazy-height="60"
												:lazy-width="60"
												/>
											</figure>
										</a>
									</div>
									<div class="column is-9 has-text-centered">
										<div class="display-table height-full w-100">
											<div class="display-table-cell vertical-align">
												<p class="has-text-primary link-hvr-primary">{{ product.product_name }}  </p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="column is-5 has-text-primary is-size-6">
								<div class="columns height-full">
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<p>{{ product.subtotal }} {{ t('currency')}}</p>
											</div>
										</div>
									</div>
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<div class="field">
													<div class="control has-text-centered">
														<p v-if="CategoryType === 'quantity'" class="has-text-primary">{{ product.quantity }}</p>
														<p v-if="CategoryType === 'date'" class="has-text-primary is-size-7">
															<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
															<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
														</p>
														<p v-if="CategoryType === 'date_time'" class="has-text-primary is-size-7">
															{{ product.start_date }} {{ product.start_time }}
														</p>
														<p v-if="CategoryType === 'fixed_date'" class="has-text-primary">
															<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
															<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button>
												<br/>
												<button v-show="CategoryType === 'date_time'" class="has-text-warning button show-button is-size-5" @click="controlEditDate(product)"><i class="far fa-calendar-alt"></i></button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'pending'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 height-42" @click.prevent="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey"  @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'pending'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 height-42" @click.prevent="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey"  @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'canceled'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<span class="btn-transparent has-text-grey">{{ t('canceled') }}</span>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'delivered'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<span class="btn-transparent has-text-grey">{{ t('delivered') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="orders-table-mobile is-size-7">
					<div v-for="product in pendingProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns is-mobile">
							<div class="column is-3-tablet is-3-mobile">
								<a rel="noreferrer" href="#">
									<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
										<lazy-load
										src="/front/img/spinner.svg"
										:lazy-src="product.image"
										:lazy-srcset="product.image"
										background-color="transparent"
										:alt="product.product_name"
										class="mr-auto hvr-grow"
										:lazy-height="60"
										:lazy-width="60"

										/>
									</figure>
								</a>
							</div>
							<div class="column is-9-tablet is-9-mobile">
								<p class="has-text-primary link-hvr-primary">{{ product.product_name }} </p>

								<div class="columns is-mobile is-multiline">
									<div class="column is-12">
										<p class="has-text-grey">{{ t('product_price')}}  : <span class="has-text-primary">{{ product.subtotal }} {{ t('currency')}}</span></p>

										<p v-if="CategoryType === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ product.quantity }}</span></p>
										<p v-if="CategoryType === 'date'" class="has-text-grey">
											<span class="has-text-primary">
												<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
												<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
											</span>
										</p>
										<p v-if="CategoryType === 'date_time'" class="has-text-grey">
											{{ t('date_time')}}:
											<span class="has-text-primary">
												{{ product.start_date }} {{ product.start_time }}
											</span>
										</p>
										<p v-if="CategoryType === 'fixed_date'" class="has-text-grey">
											<span class="has-text-primary">
												<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
												<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
											</span>
										</p>
										<p class="has-text-grey">{{ t('details')}} : <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button></p>
                                        <p v-show="CategoryType === 'date_time'" class="has-text-grey">{{ t('edit')}} : <button class="has-text-warning button show-button is-size-5" @click="editDate(product)"><i class="far fa-calendar-alt"></i></button></p>
									</div>
									<div v-if="product.status == 'pending'" class="column is-12">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr10 pl10 height-42 is-size-7" @click="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey is-size-7" @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
									<div v-if="product.status == 'delivered'" class="column is-6">
										<span class="btn-transparent has-text-grey is-size-7">{{ t('delivered') }}</span>
									</div>
									<div v-if="product.status == 'canceled'" class="column is-6">
										<span class="btn-transparent has-text-grey is-size-7">{{ t('canceled') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="has-text-centered mb20">
					<button v-if="pendingProducts.length > 1" @click="deleteAll" class="is-inline-block button is-grey hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30">{{ t('cancel_all') }}</button>
				</div>
			</tab-pane>
			<tab-pane :label="t('done')" selected>
				<div class="p10 has-text-weight-bold orders-table-header">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<p class="has-text-centered has-text-grey">{{ t('product_image') }}</p>
								</div>
								<div class="column is-9 has-text-right">
									<p class="has-text-centered has-text-grey">{{ t('product_name') }}</p>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary">
							<div class="columns height-full">
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('product_price') }}</p>
								</div>
								<div class="column is-4">
									<p v-if="CategoryType === 'quantity'" class="has-text-centered has-text-grey">{{ t('quantity') }}</p>
									<p v-if="CategoryType === 'date'" class="has-text-centered has-text-grey">{{ t('date') }}</p>
									<p v-if="CategoryType === 'date_time'" class="has-text-centered has-text-grey">{{ t('date_time') }}</p>
									<p v-if="CategoryType === 'fixed_date'" class="has-text-centered has-text-grey">{{ t('period') }}</p>
								</div>
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('details')}}</p>
								</div>
							</div>
						</div>
						<div class="column is-2">
						</div>
					</div>
				</div>
				<div v-if="agentDesktop" class="orders-table-desktop">
					<div v-for="product in doneProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns">
							<div class="column is-5">
								<div class="columns height-full">
									<div class="column is-3">
										<a rel="noreferrer" href="#">
											<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
												<lazy-load
												src="/front/img/spinner.svg"
												:lazy-src="product.image"
												:lazy-srcset="product.image"
												background-color="transparent"
												:alt="product.product_name"
												class="hvr-grow"
												:lazy-height="60"
												:lazy-width="60"
												/>
											</figure>
										</a>
									</div>
									<div class="column is-9 has-text-centered">
										<div class="display-table height-full w-100">
											<div class="display-table-cell vertical-align">
												<p class="has-text-primary link-hvr-primary">{{ product.product_name }}  </p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="column is-5 has-text-primary is-size-6">
								<div class="columns height-full">
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<p>{{ product.subtotal }} {{ t('currency')}}</p>
											</div>
										</div>
									</div>
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<div class="field">
													<div class="control has-text-centered">
														<p v-if="CategoryType === 'quantity'" class="has-text-primary">{{ product.quantity }}</p>
														<p v-if="CategoryType === 'date'" class="has-text-primary is-size-7">
															<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
															<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
														</p>
														<p v-if="CategoryType === 'date_time'" class="has-text-primary is-size-7">
															{{ product.start_date }} {{ product.start_time }}
														</p>
														<p v-if="CategoryType === 'fixed_date'" class="has-text-primary">
															<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
															<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'pending'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 height-42" @click.prevent="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey"  @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'pending'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 height-42" @click.prevent="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey"  @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'canceled'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<span class="btn-transparent has-text-grey">{{ t('canceled') }}</span>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'delivered'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<span class="btn-transparent has-text-grey">{{ t('delivered') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="orders-table-mobile is-size-7">
					<div v-for="product in doneProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns is-mobile">
							<div class="column is-3-tablet is-3-mobile">
								<a rel="noreferrer" href="#">
									<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
										<lazy-load
										src="/front/img/spinner.svg"
										:lazy-src="product.image"
										:lazy-srcset="product.image"
										background-color="transparent"
										:alt="product.product_name"
										class="mr-auto hvr-grow"
										:lazy-height="60"
										:lazy-width="60"

										/>
									</figure>
								</a>
							</div>
							<div class="column is-9-tablet is-9-mobile">
								<p class="has-text-primary link-hvr-primary">{{ product.product_name }} </p>
								<div class="columns is-mobile">
									<div class="column is-6">
										<p class="has-text-grey">{{ t('product_price')}}  : <span class="has-text-primary">{{ product.subtotal }} {{ t('currency')}}</span></p>
										<p v-if="CategoryType === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ product.quantity }}</span></p>
										<p v-if="CategoryType === 'date'" class="has-text-grey">
											<span class="has-text-primary">
												<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
												<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
											</span>
										</p>
										<p v-if="CategoryType === 'date_time'" class="has-text-grey">
											{{ t('date_time')}}:
											<span class="has-text-primary">
												{{ product.start_date }} {{ product.start_time }}
											</span>
										</p>
										<p v-if="CategoryType === 'fixed_date'" class="has-text-grey">
											<span class="has-text-primary">
												<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
												<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
											</span>
										</p>
										<p class="has-text-grey">{{ t('details')}} : <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button></p>
									</div>
									<div v-if="product.status == 'pending'" class="column is-6">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr10 pl10 height-42 is-size-7" @click="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey is-size-7" @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
									<div v-if="product.status == 'delivered'" class="column is-6">
										<span class="btn-transparent has-text-grey is-size-7">{{ t('delivered') }}</span>
									</div>
									<div v-if="product.status == 'canceled'" class="column is-6">
										<span class="btn-transparent has-text-grey is-size-7">{{ t('canceled') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</tab-pane>
			<tab-pane :label="t('deleted')" selected>
				<div class="p10 has-text-weight-bold orders-table-header">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<p class="has-text-centered has-text-grey">{{ t('product_image') }}</p>
								</div>
								<div class="column is-9 has-text-right">
									<p class="has-text-centered has-text-grey">{{ t('product_name') }}</p>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary">
							<div class="columns height-full">
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('product_price') }}</p>
								</div>
								<div class="column is-4">
									<p v-if="CategoryType === 'quantity'" class="has-text-centered has-text-grey">{{ t('quantity') }}</p>
									<p v-if="CategoryType === 'date'" class="has-text-centered has-text-grey">{{ t('date') }}</p>
									<p v-if="CategoryType === 'date_time'" class="has-text-centered has-text-grey">{{ t('date_time') }}</p>
									<p v-if="CategoryType === 'fixed_date'" class="has-text-centered has-text-grey">{{ t('period') }}</p>
								</div>
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('details')}}</p>
								</div>
							</div>
						</div>
						<div class="column is-2">
						</div>
					</div>
				</div>
				<div v-if="agentDesktop" class="orders-table-desktop">
					<div v-for="product in deletedProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns">
							<div class="column is-5">
								<div class="columns height-full">
									<div class="column is-3">
										<a rel="noreferrer" href="#">
											<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
												<lazy-load
												src="/front/img/spinner.svg"
												:lazy-src="product.image"
												:lazy-srcset="product.image"
												background-color="transparent"
												:alt="product.product_name"
												class="hvr-grow"
												:lazy-height="60"
												:lazy-width="60"
												/>
											</figure>
										</a>
									</div>
									<div class="column is-9 has-text-centered">
										<div class="display-table height-full w-100">
											<div class="display-table-cell vertical-align">
												<p class="has-text-primary link-hvr-primary">{{ product.product_name }}  </p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="column is-5 has-text-primary is-size-6">
								<div class="columns height-full">
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<p>{{ product.subtotal }} {{ t('currency')}}</p>
											</div>
										</div>
									</div>
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<div class="field">
													<div class="control has-text-centered">
														<p v-if="CategoryType === 'quantity'" class="has-text-primary">{{ product.quantity }}</p>
														<p v-if="CategoryType === 'date'" class="has-text-primary is-size-7">
															<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
															<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
														</p>
														<p v-if="CategoryType === 'date_time'" class="has-text-primary is-size-7">
															{{ product.start_date }} {{ product.start_time }}
														</p>
														<p v-if="CategoryType === 'fixed_date'" class="has-text-primary">
															<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
															<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="column is-4">
										<div class="display-table height-full has-text-centered w-100">
											<div class="display-table-cell vertical-align">
												<button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'pending'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 height-42" @click.prevent="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey"  @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'pending'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr30 pl30 height-42" @click.prevent="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey"  @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'canceled'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<span class="btn-transparent has-text-grey">{{ t('canceled') }}</span>
									</div>
								</div>
							</div>
							<div v-if="product.status == 'delivered'" class="column is-2">
								<div class="display-table height-full has-text-centered w-100">
									<div class="display-table-cell vertical-align">
										<span class="btn-transparent has-text-grey">{{ t('delivered') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="orders-table-mobile is-size-7">
					<div v-for="product in deletedProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns is-mobile">
							<div class="column is-3-tablet is-3-mobile">
								<a rel="noreferrer" href="#">
									<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
										<lazy-load
										src="/front/img/spinner.svg"
										:lazy-src="product.image"
										:lazy-srcset="product.image"
										background-color="transparent"
										:alt="product.product_name"
										class="mr-auto hvr-grow"
										:lazy-height="60"
										:lazy-width="60"

										/>
									</figure>
								</a>
							</div>
							<div class="column is-9-tablet is-9-mobile">
								<p class="has-text-primary link-hvr-primary">{{ product.product_name }} </p>
								<div class="columns is-mobile">
									<div class="column is-6">
										<p class="has-text-grey">{{ t('product_price')}}  : <span class="has-text-primary">{{ product.subtotal }} {{ t('currency')}}</span></p>
										<p v-if="CategoryType === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ product.quantity }}</span></p>
										<p v-if="CategoryType === 'date'" class="has-text-grey">
											<span class="has-text-primary">
												<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
												<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
											</span>
										</p>
										<p v-if="CategoryType === 'date_time'" class="has-text-grey">
											{{ t('date_time')}}:
											<span class="has-text-primary">
												{{ product.start_date }} {{ product.start_time }}
											</span>
										</p>
										<p v-if="CategoryType === 'fixed_date'" class="has-text-grey">
											<span class="has-text-primary">
												<small class="has-text-grey">{{ t('from')}}:</small> {{ product.start_date }}<br/>
												<small class="has-text-grey">{{ t('to')}}:</small> {{ product.finish_date }}
											</span>
										</p>
										<p class="has-text-grey">{{ t('details')}} : <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button></p>
									</div>
									<div v-if="product.status == 'pending'" class="column is-6">
										<button class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pr10 pl10 height-42 is-size-7" @click="confirmProduct(product)">
											<span>{{ t('accept') }}</span>
										</button>
										<button class="button btn-transparent has-text-grey is-size-7" @click.prevent="deleteProduct(product)">{{ t('not_available') }}</button>
									</div>
									<div v-if="product.status == 'delivered'" class="column is-6">
										<span class="btn-transparent has-text-grey is-size-7">{{ t('delivered') }}</span>
									</div>
									<div v-if="product.status == 'canceled'" class="column is-6">
										<span class="btn-transparent has-text-grey is-size-7">{{ t('canceled') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</tab-pane>
		</tabs>
		<div v-if="selectedProduct" class="modal" :class="{ 'is-active': controlConfirmModal || controlDeleteModal || controlDetailsModal || controlDateModal }">
			<div class="modal-background is-white"></div>
			<div class="card modal-content">
				<div class="overflow-hidden has-text-centered">
					<div class="has-background-warning has-text-white has-text-weight-bold p5">
						<p class="has-text-centered is-size-6">
							<template v-if="controlConfirmModal">
								{{ t('accept') }}
							</template>
							<template v-if="controlDeleteModal">
								{{ t('cancel') }}
							</template>
							<template v-if="controlDetailsModal">
								{{ t('details') }}
							</template>
                            <template v-if="controlDateModal">
								{{ t('edit') }}
							</template>

						</p>
					</div>
                <div class="p25" v-if="controlDateModal">
            <div class="datetime-container is-warning">
              <VueCtkDateTimePicker
                :min-date="todayDate"
                color="#248dcd"
                button-color="#248dcd"
                :onlyDate="true"
                :right="true"
                :buttonNowTranslation="t('today')"
                formatted="ll"
                :label="t('edit_date')"
                v-model="selectedProduct.start_date"
                format="YYYY-MM-DD">
              </VueCtkDateTimePicker>
            </div>
            <div class="datetime-container is-warning">
              <VueCtkDateTimePicker
                color="#248dcd"
                button-color="#248dcd"
                :onlyTime="true"
                :right="true"
                :buttonNowTranslation="t('today')"
                formatted="hh:mm a"
                :label="t('edit_time')"
                v-model="selectedProduct.start_time"
                format="hh:mm a">
              </VueCtkDateTimePicker>

            </div>
            <div class="buttons-conatiner">
              <button  class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="editDate" >{{ t('accept') }}</button>
              <button type="button"  class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="closeModal" >{{ t('cancel')}}</button>
            </div>
					</div>
					<div class="p25" v-if="!controlDetailsModal">
						<div v-if="controlConfirmModal">
							<!--<p>scan</p>-->
							<qrcode-stream @decode="onDecode"></qrcode-stream>
							<input id="code" name="code" class="input line-input is-primary has-text-centered" v-model="form.code" v-validate="{ required: true ,min:9}" :class="{'is-danger': errors.has('code') }" type="text" placeholder="ادخل كود العميل">
						</div>
						<button v-if="controlConfirmModal" class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="validateForm">{{ t('accept') }}</button>
						<button v-if="controlDeleteModal" class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="validateDelete()">{{ t('cancel_confirm')}}</button>
					</div>
					<div v-else class="p25 has-text-right">
            <div class="columns is-vcentered">
              <div class="column is-3">
                <figure class="mr-auto image image-contain-height is-128x128">
                  <lazy-load
                  src="/front/img/spinner.svg"
                  :lazy-src="selectedProduct.image"
                  :lazy-srcset="selectedProduct.image"
                  background-color="transparent"
                  alt="slider" class="hvr-grow"
                  />
                </figure>
              </div>
              <div class="column is-9">
                <p class="mb20 has-text-warning is-size-6 has-text-weight-bold">{{selectedProduct.product_name}}</p>
                <p class="has-text-grey">{{ t('client_name') }}  : <span class="has-text-primary">{{ selectedProduct.client_name }}</span></p>
                <p class="has-text-grey">{{ t('client_phone') }}  : <span class="has-text-primary">{{ selectedProduct.client_phone }}</span></p>
                <p class="has-text-grey">{{ t('product_price') }}  : <span class="has-text-primary">{{ selectedProduct.subtotal }} {{ t('currency')}}</span></p>
                <p v-if="selectedProduct.category_type === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ selectedProduct.quantity }}</span></p>
                <p v-if="selectedProduct.category_type === 'date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ selectedProduct.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ selectedProduct.finish_date }}
                  </span>
                </p>
                <p v-if="selectedProduct.category_type === 'date_time'" class="has-text-grey">
                  {{ t('date_time')}}:
                  <span class="has-text-primary">
                    {{ selectedProduct.start_date }} {{ selectedProduct.start_time }}
                  </span>
                </p>
                <p v-if="selectedProduct.category_type === 'fixed_date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ selectedProduct.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ selectedProduct.finish_date }}
                  </span>
                </p>
                <p class="has-text-grey">{{ t('total')}} : <span class="has-text-primary">{{ selectedProduct.total }} {{ t('currency')}}</span></p>
              </div>
            </div>
          </div>
				</div>
			</div>
			<button class="modal-close is-large has-background-warning" aria-label="close" @click="closeModal"></button>
		</div>
		<div v-if="controlConfirmAllModal || controlDeleteAllModal" class="modal" :class="{ 'is-active': controlConfirmAllModal || controlDeleteAllModal }">
			<div class="modal-background is-white"></div>
			<div class="card modal-content">
				<div class="overflow-hidden has-text-centered">
					<div class="has-background-warning has-text-white has-text-weight-bold p5">
						<p class="has-text-centered is-size-6">
							<template v-if="controlConfirmAllModal">
								{{ t('accept_all') }}
							</template>
							<template v-if="controlDeleteAllModal">
								{{ t('cancel_all') }}
							</template>
						</p>
					</div>
					<div class="p25">
						<button v-if="controlConfirmAllModal" class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="validateConfirmAll">{{ t('accept_confirm_all') }}</button>
						<button v-if="controlDeleteAllModal" class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="validateDeleteAll">{{ t('cancel_confirm_all')}}</button>
					</div>
				</div>
			</div>
			<button class="modal-close is-large has-background-warning" aria-label="close" @click="closeModal"></button>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import trans from "../translation/orders.json";
    import DatePicker from '../../GeneralComponents/DatePicker';
    import TimePicker from '../../GeneralComponents/TimePicker';
	import { Tabs, TabPane } from 'vue-bulma-tabs'
	export default {
		name: "MerchantOrders",
		components: {
			Tabs,
			TabPane,
      DatePicker,
      TimePicker
		},
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			agentDesktop:{
				type: Boolean,
				required: true
			},
			products:{
				required: true
			},
			CategoryType:{
				type: String,
				required: true
			}
		},
		locales: trans,
		data: () => ({
			controlModal:false,
			selectedProduct:null,
			controlConfirmModal:false,
			controlDeleteModal:false,
			controlDeleteAllModal : false,
			controlConfirmAllModal : false,
      controlDetailsModal:false,
			controlDateModal:false,
			form:{
				code: ''
			},
			merchant_products : [],
			pendingProducts:[],
			doneProducts:[],
			deletedProducts:[]

		}),
		mounted() {
			this.$translate.setLang(this.sitelocale);
			this.merchant_products = this.products;
			/*-----------filtering-----------*/
			let pendingProducts = this.pendingProducts;
			let doneProducts = this.doneProducts;
			let deletedProducts = this.deletedProducts;
			this.products.map(function(item){
				if(item.status == 'pending'){
					pendingProducts.push(item);
				}else if(item.status == 'delivered'){
					doneProducts.push(item);
				}
				else if(item.status == 'canceled'){
					deletedProducts.push(item);
				}

			});
		},
		created() {
		},
    computed: {
			todayDate: function () {
				let d = new Date(),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

				if (month.length < 2)
					month = '0' + month;
				if (day.length < 2)
					day = '0' + day;

				return [year, month, day].join('-');
			}
		},
		methods: {
			validateForm(){
				let editedIndex = this.pendingProducts.indexOf(this.selectedProduct);
				return this.$validator.validateAll().then((result) => {
					if(result) {
						let data = {
							'status': 'delivered',
							'user_code' : this.form.code
						};
						axios.patch(`/merchant/orders/${this.selectedProduct.id}`, data)
						.then(response => {
							let new_data = response.data.order;
							this.doneProducts.push(new_data);
							this.pendingProducts.splice(editedIndex, 1);

							this.showAlert('success', response.data.message, '', '');
							Object.assign(this.$data.form.code, '');
							this.closeModal();
						})
						.catch(error => {
							this.showAlert('error', error.response.data.message, '', '');
							if (error.response.data.reason && error.response.data.reason === 'max_sales_limit') {
                                setTimeout(()=>{
                                    window.location.href = `/${this.sitelocale}/`;
                                }, 4000);
                            }
						});
					}
				});
			},
      editDate(){
        let data = {
            'start_date': this.selectedProduct.start_date,
            'start_time' : this.selectedProduct.start_time
          };
        axios.patch(`/merchant/orders/${this.selectedProduct.id}/update_date`, data)
          .then(response => {
            this.showAlert('success', response.data.message, '', '');
            Object.assign(this.$data.form.code, '');
            this.closeModal();
          })
          .catch(error => {
            this.showAlert('error', error.response.data.message, '', '');
          });
      },
        closeModal(){
            this.controlConfirmModal = false;
            this.controlDeleteModal = false;
            this.controlConfirmAllModal = false;
            this.controlDeleteAllModal = false;
            this.controlDetailsModal = false;
            this.controlDateModal = false;
            this.selectedProduct = null;
        },
        showDetails(product){
            this.selectedProduct = product;
            this.controlDetailsModal = true;
        },
        controlEditDate(product){
            this.selectedProduct = product;
            this.controlDateModal = true;
        },
        confirmProduct(product){
            this.selectedProduct = product;
            this.controlConfirmModal = true;
        },
        deleteProduct(product){
            this.selectedProduct = product;
            this.controlDeleteModal= true;
        },
        validateDelete(){
            let editedIndex = this.pendingProducts.indexOf(this.selectedProduct);
            let data = {
                'status': 'canceled',
            };
            axios.patch(`/merchant/orders/${this.selectedProduct.id}`, data)
            .then(response => {
                let new_data = response.data.order;
                this.deletedProducts.push(new_data);
                this.pendingProducts.splice(editedIndex, 1);
                this.showAlert('success', response.data.message, '', '');
                this.closeModal();
            })
            .catch(error => {
                this.showAlert('error', error.response.data.message, '', '');
            });
        },
        confirmAll(){
            this.controlConfirmAllModal = true;
        },
        deleteAll() {
            this.controlDeleteAllModal = true;
        },
        validateConfirmAll() {
            axios.post(`/${this.sitelocale}/merchant/orders/update_all`, {'status' : 'delivered'})
            .then(response => {
                this.merchant_products = response.data.orders;
                this.showAlert('success', response.data.message, '', '');
                this.closeModal();
            })
            .catch(error => {
                this.showAlert('error', error.response.data.message, '', '');
            });
        },
        validateDeleteAll() {
            axios.post(`/${this.sitelocale}/merchant/orders/update_all`, {'status': 'canceled'})
            .then(response => {
                let a_length = this.pendingProducts.length;
                this.pendingProducts.splice(0, a_length)
                this.deletedProducts.push(...response.data.orders);

                this.showAlert('success', response.data.message, '', '');
                this.closeModal();
            })
            .catch(error => {
                this.showAlert('error', error.response.data.message, '', '');
            });
        },
        onDecode (decodedString) {
            console.log(decodedString);
            this.form.code = decodedString;
        },
        showAlert(type , title , text , html){
            this.$swal({
                type: type,
                title: title,
                text: text,
                html: html,
                showConfirmButton: false,
                timer:2000,
                customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
                backdrop: `
                rgba(36, 140, 204, 0.5)
                `
            });
        },
		},

	};
</script>
<style scoped>
	.show-button{
		border:0;
		height: auto;
	}
  .datetime-container{
    margin-top: 2rem;
  }
  .buttons-conatiner{
      margin-top: 11rem;
  }
</style>
